/* ONCALL homepage behaviour: rails, tabs, accordions and quick add for the oc-* sections */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------- horizontal rails with arrow buttons ---------- */
  function visibleRail(wrap) {
    var rails = wrap.querySelectorAll('[data-oc-rail]');
    for (var i = 0; i < rails.length; i++) if (!rails[i].hidden) return rails[i];
    return null;
  }

  function updateArrows(wrap) {
    var rail = visibleRail(wrap);
    if (!rail) return;
    var max = rail.scrollWidth - rail.clientWidth - 2;
    var prev = wrap.querySelector('[data-oc-prev]');
    var next = wrap.querySelector('[data-oc-next]');
    if (prev) prev.classList.toggle('is-on', rail.scrollLeft > 2);
    if (next) next.classList.add('is-on');
    var bar = wrap.querySelector('[data-oc-progress]');
    if (bar) {
      var seen = rail.clientWidth / Math.max(rail.scrollWidth, 1);
      var pos = max > 0 ? rail.scrollLeft / max : 1;
      bar.style.width = Math.max(seen, 0.08) * 100 + '%';
      bar.style.left = pos * (1 - Math.max(seen, 0.08)) * 100 + '%';
    }
  }

  function initRails(root) {
    root.querySelectorAll('[data-oc-railwrap]').forEach(function (wrap) {
      if (wrap.dataset.ocRailReady) return;
      wrap.dataset.ocRailReady = '1';
      function step(dir) {
        var rail = visibleRail(wrap);
        if (!rail) return;
        var max = rail.scrollWidth - rail.clientWidth - 2;
        if (dir > 0 && rail.scrollLeft >= max) {
          rail.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          rail.scrollBy({ left: dir * rail.clientWidth * 0.8, behavior: 'smooth' });
        }
        if (rail._ocPause) rail._ocPause(5000);
      }
      var prev = wrap.querySelector('[data-oc-prev]');
      var next = wrap.querySelector('[data-oc-next]');
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      wrap.querySelectorAll('[data-oc-rail]').forEach(function (rail) {
        rail.addEventListener('scroll', function () { updateArrows(wrap); }, { passive: true });
      });
      window.addEventListener('resize', function () { updateArrows(wrap); });
      updateArrows(wrap);
    });
  }

  /* ---------- women / men toggles ---------- */
  function initTabs(root) {
    root.querySelectorAll('[data-oc-tabs]').forEach(function (sec) {
      if (sec.dataset.ocTabsReady) return;
      sec.dataset.ocTabsReady = '1';
      var btns = sec.querySelectorAll('[data-oc-tab]');
      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var key = btn.dataset.ocTab;
          btns.forEach(function (b) {
            var on = b === btn;
            b.classList.toggle('is-on', on);
            b.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          sec.querySelectorAll('[data-oc-panel]').forEach(function (p) {
            p.hidden = p.dataset.ocPanel !== key;
            if (!p.hidden) p.scrollLeft = 0;
          });
          if (sec.hasAttribute('data-oc-railwrap')) updateArrows(sec);
        });
      });
    });
  }

  /* ---------- "designed around your shift" auto-rotating tabs ---------- */
  function initFeat(root) {
    root.querySelectorAll('[data-oc-feat]').forEach(function (feat) {
      if (feat.dataset.ocFeatReady) return;
      feat.dataset.ocFeatReady = '1';
      var tabs = feat.querySelectorAll('[data-oc-feat-tab]');
      if (!tabs.length) return;
      var dur = (parseFloat(getComputedStyle(feat).getPropertyValue('--oc-dur')) || 7) * 1000;
      var current = 0;
      var timer = null;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function show(i) {
        current = i;
        tabs.forEach(function (t, n) { t.classList.toggle('is-on', n === i); });
        feat.querySelectorAll('[data-oc-feat-img]').forEach(function (el) {
          el.classList.toggle('is-on', el.dataset.ocFeatImg === String(i));
        });
        feat.querySelectorAll('[data-oc-feat-chip]').forEach(function (el) {
          el.hidden = el.dataset.ocFeatChip !== String(i);
        });
      }
      function schedule() {
        clearTimeout(timer);
        if (reduce || tabs.length < 2) return;
        timer = setTimeout(function () { show((current + 1) % tabs.length); schedule(); }, dur);
      }
      // restart the progress bar on the active tab
      function run() {
        feat.classList.remove('is-run');
        void feat.offsetWidth;
        feat.classList.add('is-run');
      }
      tabs.forEach(function (t, n) {
        function go() { show(n); run(); schedule(); }
        t.addEventListener('click', go);
        t.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); } });
      });
      show(0);
      // the cycle waits until the section is properly on screen, then always starts from the first tab
      if (!('IntersectionObserver' in window)) { run(); schedule(); return; }
      var inView = false;
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var seen = e.isIntersecting && (e.intersectionRatio >= 0.5 || e.intersectionRect.height >= window.innerHeight * 0.5);
        if (seen && !inView) { inView = true; show(0); run(); schedule(); }
        else if (!e.isIntersecting && inView) { inView = false; clearTimeout(timer); feat.classList.remove('is-run'); }
      }, { threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1] }).observe(feat);
    });
  }

  /* ---------- accordions ---------- */
  function initAccordions(root) {
    // cloud comfort: one open at a time
    root.querySelectorAll('[data-oc-acc]').forEach(function (acc) {
      if (acc.dataset.ocAccReady) return;
      acc.dataset.ocAccReady = '1';
      var items = acc.children;
      Array.prototype.forEach.call(items, function (item) {
        var btn = item.querySelector('.at');
        if (!btn) return;
        btn.addEventListener('click', function () {
          Array.prototype.forEach.call(items, function (other) {
            var on = other === item;
            other.classList.toggle('is-on', on);
            var b = other.querySelector('.at');
            if (b) {
              b.setAttribute('aria-expanded', on ? 'true' : 'false');
              var i = b.querySelector('i');
              if (i) i.textContent = on ? '–' : '+';
            }
          });
        });
      });
    });

    // FAQ: each question toggles on its own
    root.querySelectorAll('[data-oc-faq] .q h3 button').forEach(function (btn) {
      if (btn.dataset.ocReady) return;
      btn.dataset.ocReady = '1';
      btn.addEventListener('click', function () {
        var q = btn.closest('.q');
        var open = !q.classList.contains('open');
        q.classList.toggle('open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        var i = btn.querySelector('i');
        if (i) i.textContent = open ? '−' : '+';
      });
    });

    // footer columns collapse on mobile
    root.querySelectorAll('[data-oc-col] h4 button').forEach(function (btn) {
      if (btn.dataset.ocReady) return;
      btn.dataset.ocReady = '1';
      btn.addEventListener('click', function () {
        var col = btn.closest('[data-oc-col]');
        var open = !col.classList.contains('is-open');
        col.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------- product cards: colour swatches + quick add ---------- */
  function cardData(card) {
    if (card._ocData !== undefined) return card._ocData;
    var el = card.querySelector('[data-oc-json]');
    try { card._ocData = el ? JSON.parse(el.textContent) : null; } catch (e) { card._ocData = null; }
    return card._ocData;
  }

  function renderSizes(card, variants) {
    var q = card.querySelector('[data-oc-qsz]');
    if (q) {
      q.querySelectorAll('button').forEach(function (b) { b.remove(); });
      variants.forEach(function (v) {
        var b = document.createElement('button');
        b.type = 'button';
        b.dataset.id = v.id;
        b.textContent = v.size;
        if (v.pre) { b.className = 'pre'; b.title = 'Pre-order'; }
        if (!v.available) b.disabled = true;
        q.appendChild(b);
      });
    }
    var box = card.querySelector('[data-oc-sizes]');
    if (!box) return;
    box.innerHTML = '';
    variants.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button';
      b.dataset.id = v.id;
      b.textContent = v.size;
      if (v.pre) { b.className = 'pre'; b.title = 'Pre-order'; }
      if (!v.available) b.disabled = true;
      box.appendChild(b);
    });
  }

  function setAtb(card, text, ms) {
    var atb = card.querySelector('[data-oc-atb]');
    if (!atb) return;
    atb.textContent = text;
    clearTimeout(atb._ocT);
    if (ms) atb._ocT = setTimeout(function () { atb.textContent = 'Add to bag'; }, ms);
  }

  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  // adds variant ids to the cart; resolves with { ok, json, target }
  function postCart(ids, qty) {
    var drawer = document.querySelector('cart-drawer');
    var notification = document.querySelector('cart-notification');
    var target = drawer || notification;
    // an id can be "variant:sellingPlan" for a size on pre-order
    var body = { items: ids.map(function (id) {
      var p = String(id).split(':');
      var it = { id: Number(p[0]), quantity: qty || 1 };
      if (p[1]) it.selling_plan = Number(p[1]);
      return it;
    }) };
    if (target && typeof target.getSectionsToRender === 'function') {
      body.sections = target.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    return fetch(cartRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j, target: target, drawer: drawer }; }); });
  }
  // opens the theme's cart drawer with the new items, or goes to the cart page
  function showCart(res) {
    document.querySelectorAll('.oc-dialog[open]').forEach(closeDialog);
    var item = res.json.items ? res.json.items[0] : res.json;
    if (res.target && typeof res.target.renderContents === 'function' && res.json.sections) {
      item.sections = res.json.sections;
      if (res.drawer && res.drawer.classList.contains('is-empty')) res.drawer.classList.remove('is-empty');
      res.target.renderContents(item);
    } else {
      window.location.href = cartRoot() + 'cart';
    }
  }

  function addToCart(card, variantId) {
    setAtb(card, 'Adding…');
    return postCart([variantId])
      .then(function (res) {
        if (!res.ok) {
          setAtb(card, res.json && res.json.description ? 'Sold out' : 'Try again', 2500);
          return;
        }
        setAtb(card, 'Added ✓', 2000);
        if (!card.closest('.oc-dialog')) card.classList.remove('qa-open');
        showCart(res);
      })
      .catch(function () { window.location.href = cartRoot() + 'cart'; });
  }

  function initCards(root) {
    root.querySelectorAll('[data-oc-card]').forEach(function (card) {
      if (card.dataset.ocReady) return;
      card.dataset.ocReady = '1';

      function applySwatch(sw) {
        if (sw.classList.contains('is-on')) return;
        var data = cardData(card);
        var d = data && data[sw.dataset.ocSw];
        if (!d) return;
        card.querySelectorAll('[data-oc-sw]').forEach(function (b) { b.classList.toggle('is-on', b === sw); });
        var img = card.querySelector('.ph img[data-oc-img]') || card.querySelector('.ph img');
        if (img && d.img) {
          img.removeAttribute('srcset');
          img.src = d.img;
          img.alt = d.alt;
        }
        var hov = card.querySelector('[data-oc-hov]');
        if (hov) { if (d.hov) { hov.src = d.hov; hov.hidden = false; } else hov.hidden = true; }
        card.querySelectorAll('[data-oc-link]').forEach(function (a) { a.href = d.url; });
        var price = card.querySelector('[data-oc-price]');
        if (price) price.innerHTML = d.price;
        var meta = card.querySelector('[data-oc-meta]');
        if (meta) meta.textContent = d.colour + (d.desc ? ' · ' + d.desc : '');
        var off = card.querySelector('[data-oc-off]');
        if (off) { off.hidden = !d.off; off.textContent = d.off + '% off'; }
        var badge = card.querySelector('[data-oc-badge]');
        if (badge) {
          badge.textContent = d.best ? 'Best seller' : d.new ? 'New' : '';
          badge.hidden = !d.best && !d.new;
        }
        card._ocCur = d;
        renderSizes(card, d.variants);
        card._ocSel = null;
        setAtb(card, 'Add to bag');
      }

      card._ocApply = applySwatch;
      // hovering a colour previews it (desktop); tapping does the same on touch screens
      card.addEventListener('mouseover', function (e) {
        var sw = e.target.closest('[data-oc-sw]');
        if (sw && window.matchMedia('(hover: hover)').matches) applySwatch(sw);
      });

      card.addEventListener('click', function (e) {
        var sw = e.target.closest('[data-oc-sw]');
        if (sw) {
          e.preventDefault();
          applySwatch(sw);
          return;
        }

        var qs = e.target.closest('[data-oc-qsz] button');
        if (qs) {
          e.preventDefault();
          if (qs.disabled || card._ocQBusy) return;
          var lab = card.querySelector('[data-oc-qsz-label]');
          card._ocQBusy = true;
          if (lab) lab.textContent = 'Adding ' + qs.textContent + '…';
          addToCart(card, qs.dataset.id).then(function () {
            if (lab) lab.textContent = 'Added ✓';
            setTimeout(function () { if (lab) lab.textContent = 'Quick add'; }, 2000);
          }, function () {}).then(function () { card._ocQBusy = false; });
          return;
        }

        if (e.target.closest('[data-oc-plus]')) {
          e.preventDefault();
          if (card.hasAttribute('data-oc-grid-card')) openQuickSheet(card);
          else card.classList.toggle('qa-open');
          return;
        }

        var size = e.target.closest('[data-oc-sizes] button');
        if (size && !size.disabled) {
          e.preventDefault();
          card.querySelectorAll('[data-oc-sizes] button').forEach(function (b) { b.classList.toggle('is-sel', b === size); });
          card._ocSel = size.dataset.id;
          setAtb(card, (size.classList.contains('pre') ? 'Pre-order size ' : 'Add size ') + size.textContent);
          return;
        }

        if (e.target.closest('[data-oc-atb]')) {
          e.preventDefault();
          if (!card._ocSel) {
            var avail = card.querySelectorAll('[data-oc-sizes] button:not([disabled])');
            setAtb(card, avail.length ? 'Pick a size' : 'Sold out', 1800);
            return;
          }
          addToCart(card, card._ocSel);
        }
      });
    });
  }

  /* ---------- slow auto-scroll for rails with data-oc-autoplay ---------- */
  function initAutoplay(root) {
    if (!window.matchMedia || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    root.querySelectorAll('[data-oc-autoplay]').forEach(function (rail) {
      if (rail.dataset.ocAutoReady) return;
      rail.dataset.ocAutoReady = '1';
      var speed = parseFloat(rail.dataset.ocAutoplay) || 30; // px per second
      var pos = rail.scrollLeft;
      var pausedUntil = 0;
      var hovering = false;
      var visible = false;
      var last = 0;
      var looping = false;

      // snapping would fight the slow drift, so the rail scrolls freely
      rail.style.scrollSnapType = 'none';
      rail.style.scrollBehavior = 'auto';

      rail._ocPause = function (ms) { pausedUntil = Date.now() + (ms || 4000); };
      rail.addEventListener('mouseenter', function () { hovering = true; });
      rail.addEventListener('mouseleave', function () { hovering = false; pos = rail.scrollLeft; });
      ['pointerdown', 'wheel', 'touchstart', 'focusin'].forEach(function (ev) {
        rail.addEventListener(ev, function () { rail._ocPause(4000); }, { passive: true });
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; }).observe(rail);
      } else {
        visible = true;
      }

      function tick(t) {
        var dt = last ? Math.min(t - last, 100) : 0;
        last = t;
        var openDialog = document.querySelector('.oc-dialog[open]');
        if (visible && !hovering && !openDialog && !looping && Date.now() > pausedUntil && !document.hidden) {
          var max = rail.scrollWidth - rail.clientWidth;
          if (Math.abs(rail.scrollLeft - pos) > 2) pos = rail.scrollLeft; // someone else moved it
          pos += (speed * dt) / 1000;
          if (pos >= max - 1) {
            looping = true;
            setTimeout(function () {
              rail.scrollTo({ left: 0, behavior: 'smooth' });
              setTimeout(function () { pos = 0; looping = false; }, 1200);
            }, 1500);
          } else {
            rail.scrollLeft = pos;
          }
        } else {
          pos = rail.scrollLeft;
        }
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    });
  }

  /* ---------- header height, so the hero can leave room for the trust strip ---------- */
  function measureHeader() {
    var first = document.querySelector('.oc:not(.oc-hd)');
    if (!first) return;
    var top = first.getBoundingClientRect().top + window.scrollY;
    var sticky = 0;
    // whichever header is showing: the redesign header on desktop, the theme header below 990px
    document.querySelectorAll('.oc-hd-section, .shopify-section-header-sticky, .section-header').forEach(function (hdr) {
      var cs = getComputedStyle(hdr);
      var h = hdr.getBoundingClientRect().height;
      if (sticky || !h || (cs.position !== 'sticky' && cs.position !== 'fixed')) return;
      sticky = h + Math.min(0, parseFloat(cs.top) || 0); // a negative top means the announcement bar scrolls away
    });
    document.documentElement.style.setProperty('--oc-head', Math.round(top) + 'px');
    document.documentElement.style.setProperty('--oc-sticky', Math.round(sticky) + 'px');
  }

  /* ---------- pop-ups: size guide and shop the look ---------- */
  function openDialog(d) {
    if (!d) return;
    if (typeof d.showModal === 'function') d.showModal();
    else d.setAttribute('open', '');
    document.documentElement.classList.add('oc-lock');
  }
  function closeDialog(d) {
    if (!d) return;
    if (typeof d.close === 'function' && d.open) d.close();
    else d.removeAttribute('open');
    document.documentElement.classList.remove('oc-lock');
  }

  function initDialogs() {
    if (document.documentElement.dataset.ocDialogs) return;
    document.documentElement.dataset.ocDialogs = '1';
    document.addEventListener('click', function (e) {
      var sgLink = e.target.closest('.oc a[href*="/pages/size-chart"], [data-oc-sizeguide]');
      var sg = document.querySelector('[data-oc-sg]');
      if (sgLink && sg) {
        e.preventDefault();
        // on a Women's or Men's page only that gender's charts show
        var gEl = document.querySelector('[data-oc-gender]');
        var g = gEl ? gEl.dataset.ocGender : '';
        // chart ids on the size chart page start "mens-" or "womens-";
        // a product page narrows it further to its own chart ("mens-bottoms")
        var pre = gEl && gEl.dataset.ocSgPre && !sgLink.closest('.qdialog') ? gEl.dataset.ocSgPre : g ? g + 's-' : '';
        var secs = sg.querySelectorAll('.sg-body section');
        var match = Array.prototype.filter.call(secs, function (sec) {
          var id = ' ' + (sec.getAttribute('aria-labelledby') || '') + ' ' + ((sec.querySelector('h3[id]') || {}).id || '');
          return id.indexOf(' ' + pre) > -1;
        });
        // if nothing matches (page wording changed), show every chart rather than an empty guide
        secs.forEach(function (sec) { sec.hidden = !!pre && match.length > 0 && match.indexOf(sec) < 0; });
        // one pop-up at a time: close quick add / shop the set first, and go back to it
        // (with the sizes already picked) when the size guide closes
        var from = sgLink.closest('.oc-dialog');
        sg._ocReturn = from && from !== sg ? from : null;
        document.querySelectorAll('.oc-dialog[open]').forEach(function (d) { if (d !== sg) closeDialog(d); });
        openDialog(sg);
        return;
      }
      var lookBtn = e.target.closest('[data-oc-look-open]');
      if (lookBtn) {
        e.preventDefault();
        var scope = lookBtn.closest('.oc');
        var tpl = scope.querySelector('template[data-oc-look="' + lookBtn.dataset.ocLookOpen + '"]');
        var dlg = scope.querySelector('[data-oc-look-dialog]');
        if (!tpl || !dlg) return;
        var body = dlg.querySelector('[data-oc-look-body]');
        body.innerHTML = '';
        body.appendChild(tpl.content.cloneNode(true));
        initCards(body);
        body.querySelectorAll('[data-oc-card]').forEach(function (c) { c.classList.add('qa-open'); });
        openDialog(dlg);
        return;
      }
      if (e.target.closest('[data-oc-dialog-close]')) {
        closeDialog(e.target.closest('.oc-dialog'));
        return;
      }
      // click on the dimmed backdrop closes
      if (e.target.classList && e.target.classList.contains('oc-dialog')) closeDialog(e.target);
    });
    document.addEventListener('close', function (e) {
      if (e.target.classList && e.target.classList.contains('oc-dialog') && !document.querySelector('.oc-dialog[open]')) document.documentElement.classList.remove('oc-lock');
      var back = e.target._ocReturn;
      if (back) {
        e.target._ocReturn = null;
        openDialog(back);
      }
    }, true);
  }

  /* ---------- drag to scroll rails with a mouse ---------- */
  function initDrag(root) {
    if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    root.querySelectorAll('[data-oc-rail]').forEach(function (rail) {
      if (rail.dataset.ocDragReady) return;
      rail.dataset.ocDragReady = '1';
      var startX = 0;
      var startLeft = 0;
      var down = false;
      var moved = false;

      rail.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        if (e.target.closest('button, input, select, textarea')) return;
        down = true;
        moved = false;
        startX = e.clientX;
        startLeft = rail.scrollLeft;
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (!moved && Math.abs(dx) > 6) {
          moved = true;
          rail.classList.add('is-dragging');
          if (rail._ocPause) rail._ocPause(5000);
        }
        if (moved) {
          rail.scrollLeft = startLeft - dx;
          e.preventDefault();
        }
      });
      window.addEventListener('pointerup', function () {
        if (!down) return;
        down = false;
        if (moved) {
          rail.classList.remove('is-dragging');
          if (rail._ocPause) rail._ocPause(5000);
          // swallow the click that follows a drag so links don't open
          var swallow = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
          rail.addEventListener('click', swallow, { capture: true, once: true });
          setTimeout(function () { rail.removeEventListener('click', swallow, true); }, 50);
        }
      });
      rail.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
  }

  /* ---------- redesign header: hand the bag click to the theme's cart icon, mirror its count ---------- */
  function initHeader() {
    var mine = document.querySelector('[data-oc-cart]');
    if (!mine || mine.dataset.ocReady) return;
    mine.dataset.ocReady = '1';
    var theirs = function () { return document.querySelector('#cart-icon-bubble'); };
    mine.addEventListener('click', function (e) {
      var t = theirs();
      if (!t) return; // no theme icon: just follow the link to the cart page
      e.preventDefault();
      t.click(); // same as clicking the theme's own bag: opens the cart drawer, or the cart app's
    });
    var count = mine.querySelector('[data-oc-cart-count]');
    function sync() {
      var t = theirs();
      if (!t || !count) return;
      var b = t.querySelector('.cart-count-bubble span[aria-hidden="true"], .cart-count-bubble');
      var n = b ? parseInt(b.textContent, 10) || 0 : 0;
      count.textContent = n;
      count.hidden = n === 0;
    }
    var t = theirs();
    if (t && 'MutationObserver' in window) {
      sync();
      new MutationObserver(sync).observe(t, { childList: true, subtree: true, characterData: true });
    }
  }


  /* ---------- collection pages ---------- */
  // quick add sheet for grid cards: the card's own sizes and Add to bag, in a bottom sheet
  function openQuickSheet(card) {
    var sheet = document.querySelector('[data-oc-qsheet]');
    if (!sheet) {
      // the dialog styles are scoped under .oc, so the sheet lives in its own .oc wrapper
      var wrap = document.createElement('div');
      wrap.className = 'oc';
      sheet = document.createElement('dialog');
      sheet.className = 'oc-dialog qdialog';
      sheet.setAttribute('data-oc-qsheet', '');
      sheet.setAttribute('aria-label', 'Quick add');
      sheet.innerHTML = '<button type="button" class="x" data-oc-dialog-close aria-label="Close">×</button><div data-oc-qbody></div>';
      wrap.appendChild(sheet);
      document.body.appendChild(wrap);
    }
    var body = sheet.querySelector('[data-oc-qbody]');
    var img = card.querySelector('.ph img');
    var link = card.querySelector('[data-oc-link]');
    var clone = document.createElement('div');
    clone.className = 'ocard qcard';
    clone.setAttribute('data-oc-card', '');
    clone.innerHTML =
      '<div class="qhead"><img alt=""><div><b class="qn"></b><span class="qp"></span></div></div>' +
      '<div class="qlab">Select size</div><div class="sizes" data-oc-sizes></div>' +
      '<button class="atb" type="button" data-oc-atb>Add to bag</button>' +
      '<a class="qfit" href="/pages/size-chart">Not sure which size? Find your fit</a>';
    clone.querySelector('.qhead img').src = img ? img.currentSrc || img.src : '';
    clone.querySelector('.qn').textContent = img ? img.alt : '';
    clone.querySelector('.qp').innerHTML = card.querySelector('[data-oc-price]').innerHTML;
    clone.querySelector('[data-oc-sizes]').innerHTML = card.querySelector('[data-oc-sizes]').innerHTML;
    body.innerHTML = '';
    body.appendChild(clone);
    initCards(body);
    openDialog(sheet);
  }

  // one card per colour (or per style, with swatches); filters and sort run over those cards in the browser
  function initCollGrid(root) {
    root.querySelectorAll('[data-oc-coll]').forEach(function (wrap) {
      if (wrap.dataset.ocReady) return;
      wrap.dataset.ocReady = '1';
      var grid = wrap.querySelector('[data-oc-grid]');
      var items = Array.prototype.slice.call(grid.querySelectorAll('.citem'));
      var state = { type: [], colour: [], size: [] };
      var sortSel = wrap.querySelector('[data-oc-sort]');

      items.forEach(function (it) {
        var card = it.querySelector('[data-oc-card]');
        var on = card.querySelector('[data-oc-sw].is-on');
        it._home = on; // the colour the card started on
      });

      function variantsOf(it) {
        var card = it.querySelector('[data-oc-card]');
        if (card._ocCur) return card._ocCur.variants;
        return Array.prototype.map.call(card.querySelectorAll('[data-oc-sizes] button'), function (b) {
          return { size: b.textContent.trim(), available: !b.disabled };
        });
      }
      function amount(it) {
        var card = it.querySelector('[data-oc-card]');
        if (card._ocCur) return card._ocCur.amount;
        var t = card.querySelector('[data-oc-price] .sale') || card.querySelector('[data-oc-price]');
        return parseFloat((t.textContent.match(/[\d.,]+/) || ['0'])[0].replace(',', '')) * 100;
      }

      function apply() {
        var shown = 0;
        items.forEach(function (it) {
          var card = it.querySelector('[data-oc-card]');
          var ok = !state.type.length || state.type.indexOf(it.dataset.type) > -1;
          if (ok && g0) ok = it.dataset.gender === g0;
          if (ok && state.colour.length && it.dataset.colour !== undefined) {
            ok = state.colour.indexOf(it.dataset.colour) > -1;
          } else if (ok && state.colour.length) {
            // switch the card to the first chosen colour this style comes in
            var data = cardData(card) || {};
            var hit = null;
            Object.keys(data).some(function (k) {
              if (data[k] && state.colour.indexOf(data[k].colour) > -1) { hit = k; return true; }
              return false;
            });
            if (hit !== null) {
              var sw = card.querySelector('[data-oc-sw="' + hit + '"]');
              if (sw) card._ocApply(sw);
              // colours past the sixth swatch have no button, so apply them directly
              else if (card._ocApply) card._ocApply({ classList: { contains: function () { return false; } }, dataset: { ocSw: hit } });
            } else ok = false;
          } else if (ok && it._home && !it._home.classList.contains('is-on')) {
            card._ocApply(it._home);
          }
          if (ok && state.size.length) {
            ok = variantsOf(it).some(function (v) { return v.available && state.size.indexOf(v.size) > -1; });
          }
          it.hidden = !ok;
          if (ok) shown++;
        });
        wrap.querySelector('[data-oc-n]').textContent = shown;
        wrap.querySelector('[data-oc-shown]').textContent = shown;
        wrap.querySelector('[data-oc-empty]').hidden = shown > 0;
        wrap.querySelectorAll('[data-oc-fbtn]').forEach(function (b) {
          var n = state[b.dataset.ocFbtn].length;
          b.classList.toggle('is-on', n > 0);
          b.querySelector('i').textContent = n ? n : '+';
        });
        sort();
      }

      function sort() {
        var mode = sortSel ? sortSel.value : 'featured';
        var list = items.slice().sort(function (a, b) {
          if (mode === 'price-asc') return amount(a) - amount(b);
          if (mode === 'price-desc') return amount(b) - amount(a);
          if (mode === 'az') return a.dataset.name.localeCompare(b.dataset.name);
          if (mode === 'best') return a.dataset.pos - b.dataset.pos;
          return (a.dataset.rank - b.dataset.rank) || (a.dataset.pos - b.dataset.pos);
        });
        list.forEach(function (it) { grid.appendChild(it); });
      }

      wrap.addEventListener('click', function (e) {
        var fb = e.target.closest('[data-oc-fbtn]');
        if (fb) {
          var panel = wrap.querySelector('[data-oc-panel="' + fb.dataset.ocFbtn + '"]');
          var open = panel.hidden;
          wrap.querySelectorAll('[data-oc-panel]').forEach(function (p) { p.hidden = true; });
          wrap.querySelectorAll('[data-oc-fbtn]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
          panel.hidden = !open;
          fb.setAttribute('aria-expanded', String(open));
          return;
        }
        var fv = e.target.closest('[data-oc-fv]');
        if (fv) {
          var key = fv.closest('[data-oc-panel]').dataset.ocPanel;
          var v = fv.dataset.ocFv;
          var i = state[key].indexOf(v);
          if (i > -1) state[key].splice(i, 1); else state[key].push(v);
          fv.classList.toggle('is-on', i < 0);
          apply();
          return;
        }
        if (e.target.closest('[data-oc-clear]')) {
          state = { type: [], colour: [], size: [] };
          wrap.querySelectorAll('[data-oc-fv].is-on').forEach(function (b) { b.classList.remove('is-on'); });
          apply();
        }
      });
      var g0 = urlGender();
      var t0 = urlType();
      if (g0 && !t0) apply();
      if (t0) {
        state.type = [TYPES[t0]];
        var b0 = wrap.querySelector('[data-oc-panel="type"] [data-oc-fv="' + TYPES[t0] + '"]');
        if (b0) b0.classList.add('is-on');
        apply();
      }
      if (sortSel) sortSel.addEventListener('change', function () {
        var lab = wrap.querySelector('[data-oc-sort-label]');
        if (lab) lab.textContent = sortSel.options[sortSel.selectedIndex].text;
        sort();
      });
      sort();
    });
  }

  // "Make it a set": style pills and colour swatches for a top and a bottom
  function initCollSet(root) {
    root.querySelectorAll('[data-oc-set]').forEach(function (sec) {
      if (sec.dataset.ocReady) return;
      sec.dataset.ocReady = '1';
      var data;
      try { data = JSON.parse(sec.querySelector('[data-oc-set-json]').textContent); } catch (e) { return; }
      var start = sec.dataset.colour || 'Navy Blue';
      var st = {};

      sec.querySelectorAll('.it').forEach(function (it) {
        var first = it.querySelector('.stp button');
        st[it.dataset.k] = { s: first ? first.dataset.s : '', c: start };
      });

      function cur(k) {
        var o = st[k];
        var style = data[o.s];
        if (!style) return null;
        var cols = Object.keys(style.colours);
        if (!cols.length) return null;
        if (!style.colours[o.c]) o.c = style.colours[start] ? start : cols[0];
        return { name: style.name, colour: o.c, p: style.colours[o.c], cols: cols, style: style };
      }

      function draw() {
        var parts = [];
        sec.querySelectorAll('.it').forEach(function (it) {
          var k = it.dataset.k;
          var c = cur(k);
          it.querySelectorAll('.stp button').forEach(function (b) {
            b.classList.toggle('is-on', b.dataset.s === st[k].s);
            b.disabled = !data[b.dataset.s] || !Object.keys(data[b.dataset.s].colours).length;
          });
          if (!c) return;
          var img = it.querySelector('[data-oc-set-img]');
          if (c.p.img) img.src = c.p.img;
          img.alt = c.name + ' - ' + c.colour;
          it.querySelector('[data-oc-set-name]').textContent = c.name;
          it.querySelector('[data-oc-set-price]').innerHTML = money(c.p.price) + (c.p.compare ? ' <s>' + money(c.p.compare) + '</s>' : '');
          it.querySelector('[data-oc-set-cn]').textContent = c.colour;
          it.querySelector('[data-oc-set-sw]').innerHTML = c.cols.map(function (n) {
            return '<button type="button" data-c="' + n + '" class="' + (n === c.colour ? 'is-on' : '') + '" style="background:' + c.style.colours[n].hex + '" aria-label="' + n + '" title="' + n + '"></button>';
          }).join('');
          parts.push({ k: k, s: st[k].s, p: c.p });
        });
        if (parts.length === 2) {
          var a = parts[0], b = parts[1];
          var full = (a.p.compare || a.p.price) + (b.p.compare || b.p.price);
          var now = a.p.price + b.p.price;
          var word = (b.s.split(' ').pop() || '').toLowerCase();
          sec.querySelector('[data-oc-sum]').innerHTML =
            'Top <em>' + money(a.p.price) + '</em>' + (a.p.compare ? ' <s>' + money(a.p.compare) + '</s>' : '') +
            ' + ' + word + ' <em>' + money(b.p.price) + '</em>' + (b.p.compare ? ' <s>' + money(b.p.compare) + '</s>' : '') +
            ' = ' + (full > now ? '<s>' + money(full) + '</s> ' : '') + '<b>' + money(now) + '</b>';
        }
      }

      sec.addEventListener('click', function (e) {
        var stp = e.target.closest('.stp button');
        if (stp) { st[stp.closest('.it').dataset.k].s = stp.dataset.s; draw(); return; }
        var sw = e.target.closest('[data-oc-set-sw] button');
        if (sw) { st[sw.closest('.it').dataset.k].c = sw.dataset.c; draw(); return; }
        if (e.target.closest('[data-oc-set-go]')) {
          openSetDialog();
        }
      });

      // "Shop the set" pop-up: a size for each piece, then Add both to bag
      var dlg = sec.querySelector('[data-oc-set-dialog]');
      var pick = {};
      function word(k) {
        if (k === 'top') return 'top';
        return (st.bot.s.split(' ').pop() || 'bottoms').toLowerCase();
      }
      function openSetDialog() {
        var body = dlg.querySelector('[data-oc-set-body]');
        pick = {};
        var parts = [];
        ['top', 'bot'].forEach(function (k) {
          var c = cur(k);
          if (!c) return;
          parts.push({ k: k, c: c });
        });
        if (parts.length < 2) return;
        var full = 0, now = 0;
        body.innerHTML = '<div class="sb-grid">' + parts.map(function (x) {
          var c = x.c;
          full += c.p.compare || c.p.price;
          now += c.p.price;
          return '<div class="sb-it" data-k="' + x.k + '">' +
            '<a class="ph" href="' + c.p.url + '"><img alt=""></a>' +
            '<div class="sb-nm"><a href="' + c.p.url + '"></a><span class="pr">' + money(c.p.price) + (c.p.compare ? '<s>' + money(c.p.compare) + '</s>' : '') + '</span></div>' +
            '<div class="sb-cn"></div>' +
            '<div class="sb-ql">Size <em data-need></em></div>' +
            '<div class="sb-sz">' + c.p.variants.map(function (v) {
              return '<button type="button" data-id="' + v.id + '"' + (v.pre ? ' class="pre" title="Pre-order"' : '') + (v.available ? '' : ' disabled') + '>' + v.size + '</button>';
            }).join('') + '</div></div>';
        }).join('') + '</div>' +
          '<a class="sb-fit" href="' + cartRoot() + 'pages/size-chart">Not sure which size? Find your fit</a>' +
          '<div class="sb-tot"><span>Set total</span><span><span class="p">' + money(now) + (full > now ? '<s>' + money(full) + '</s>' : '') + '</span>' +
          (full > now ? '<small>You save ' + money(full - now) + '</small>' : '') + '</span></div>' +
          '<button type="button" class="sb-go" data-oc-set-add disabled></button>' +
          '<p class="sb-one" hidden>Only want one piece? <span data-oc-set-ones></span></p>' +
          '<p class="sb-ok" role="status" hidden><i aria-hidden="true">✓</i><span data-oc-set-msg></span><a href="' + cartRoot() + 'cart">View bag</a></p>';
        parts.forEach(function (x) {
          var it = body.querySelector('.sb-it[data-k="' + x.k + '"]');
          var img = it.querySelector('img');
          img.src = x.c.p.img || '';
          img.alt = x.c.name + ' - ' + x.c.colour;
          it.querySelector('.sb-nm a').textContent = x.c.name;
          it.querySelector('.sb-cn').textContent = x.c.colour;
        });
        dlg._now = now;
        refresh();
        openDialog(dlg);
      }
      function refresh() {
        var body = dlg.querySelector('[data-oc-set-body]');
        var go = body.querySelector('[data-oc-set-add]');
        var missing = ['top', 'bot'].filter(function (k) { return !pick[k]; });
        body.querySelectorAll('.sb-it').forEach(function (it) {
          var k = it.dataset.k;
          it.querySelectorAll('.sb-sz button').forEach(function (b) { b.classList.toggle('is-on', !!pick[k] && pick[k].id === b.dataset.id); });
          it.querySelector('[data-need]').textContent = missing.length === 1 && !pick[k] ? 'Choose a size' : '';
        });
        go.disabled = missing.length > 0;
        go.textContent = missing.length === 2 ? 'Choose your sizes'
          : missing.length === 1 ? 'Choose ' + word(missing[0]) + ' size'
          : 'Add both to bag';
        var ones = ['top', 'bot'].filter(function (k) { return pick[k]; });
        body.querySelector('.sb-one').hidden = !ones.length;
        body.querySelector('[data-oc-set-ones]').innerHTML = ones.map(function (k) {
          return '<button type="button" data-oc-set-one="' + k + '">Add ' + word(k) + ' only</button>';
        }).join(' · ');
      }
      function addPieces(keys, btn) {
        var body = dlg.querySelector('[data-oc-set-body]');
        var label = btn.textContent;
        btn.textContent = 'Adding…';
        btn.disabled = true;
        postCart(keys.map(function (k) { return pick[k].id; }))
          .then(function (res) {
            if (!res.ok) {
              btn.textContent = res.json && res.json.description ? res.json.description : 'Try again';
              setTimeout(function () { btn.textContent = label; refresh(); }, 2500);
              return;
            }
            var said = keys.map(function (k) { return word(k).charAt(0).toUpperCase() + word(k).slice(1) + ' (' + pick[k].size + ')'; });
            body.querySelector('[data-oc-set-msg]').textContent = said.join(' and ').replace(/ and (\w)/, function (m, c) { return ' and ' + c.toLowerCase(); }) + ' added';
            body.querySelector('.sb-ok').hidden = false;
            btn.textContent = 'Added ✓';
            // show the confirmation for a moment, then the theme's cart drawer takes over
            setTimeout(function () { showCart(res); }, 1200);
          })
          .catch(function () { window.location.href = cartRoot() + 'cart'; });
      }
      if (dlg) dlg.addEventListener('click', function (e) {
        var sz = e.target.closest('.sb-sz button');
        if (sz && !sz.disabled) {
          pick[sz.closest('.sb-it').dataset.k] = { id: sz.dataset.id, size: sz.textContent };
          refresh();
          return;
        }
        var go = e.target.closest('[data-oc-set-add]');
        if (go && !go.disabled) { addPieces(['top', 'bot'], go); return; }
        var one = e.target.closest('[data-oc-set-one]');
        if (one) addPieces([one.dataset.ocSetOne], one);
      });
      draw();
    });
  }

  // mobile hero: the gradient runs down to where the photo starts
  // ?type=tops|trousers|joggers|layers on a collection URL
  var TYPES = { tops: 'Tops', trousers: 'Trousers', joggers: 'Joggers', layers: 'Lab coats & layers' };
  function urlType() {
    var m = /[?&]type=([^&#]+)/.exec(window.location.search);
    var t = m ? decodeURIComponent(m[1]).toLowerCase() : '';
    return TYPES[t] ? t : '';
  }

  function urlGender() {
    var m = /[?&]gender=(women|men)\b/i.exec(window.location.search);
    return m ? m[1].toLowerCase() : '';
  }

  function initCollHero(root) {
    root.querySelectorAll('[data-oc-chero]').forEach(function (h) {
      // All Scrubs / Best Sellers: Women and Men pills filter the grid (?gender=men)
      var gp = h.querySelectorAll('[data-oc-pill-gender]');
      if (gp.length && !h.dataset.ocGReady) {
        h.dataset.ocGReady = '1';
        var items = document.querySelectorAll('[data-oc-grid] .citem');
        if (items.length) {
          var allN = h.querySelector('[data-oc-pill="all"] span');
          if (allN) allN.textContent = items.length;
          gp.forEach(function (a) {
            var n = 0;
            items.forEach(function (it) { if (it.dataset.gender === a.dataset.ocPillGender) n++; });
            var sp = a.querySelector('em span');
            if (sp) sp.textContent = n;
          });
        }
        var g = urlGender();
        var on = g && h.querySelector('[data-oc-pill-gender="' + g + '"]');
        if (on) {
          h.querySelectorAll('.pills a.is-on').forEach(function (a) { a.classList.remove('is-on'); });
          on.classList.add('is-on');
        }
      }
      var c = h.querySelector('.cbg');
      if (!c || h.dataset.ocReady) return;
      h.dataset.ocReady = '1';
      // a pill that filters the Women/Men page (?type=layers) lights up instead of "All"
      var t = urlType();
      // and the Women/Men switch keeps that filter
      if (t) h.querySelectorAll('[data-oc-keep-type]').forEach(function (a) {
        a.href += (a.href.indexOf('?') > -1 ? '&' : '?') + 'type=' + t;
      });
      var tp = t && h.querySelector('[data-oc-pill-type="' + t + '"]');
      if (tp) {
        h.querySelectorAll('.pills a.is-on').forEach(function (a) { a.classList.remove('is-on'); });
        tp.classList.add('is-on');
      }
      function f() { h.style.setProperty('--nh', c.offsetTop + 'px'); }
      f();
      window.addEventListener('resize', f);
      window.addEventListener('load', f);
    });
  }

  /* ---------- product page ---------- */
  function initPdp(root) {
    root.querySelectorAll('[data-oc-pdp]').forEach(function (pdp) {
      if (pdp.dataset.ocReady) return;
      pdp.dataset.ocReady = '1';

      // gallery: one track of photos; thumbnails, dots and the counter follow it
      var track = pdp.querySelector('[data-oc-track]');
      var cnt = pdp.querySelector('[data-oc-cnt]');
      var thumbs = pdp.querySelectorAll('[data-oc-thumb]');
      var dots = pdp.querySelectorAll('[data-oc-dot]');
      function current() { return track ? Math.round(track.scrollLeft / Math.max(1, track.clientWidth)) : 0; }
      function mark(i) {
        if (cnt) cnt.textContent = i + 1;
        thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      }
      function go(i) { if (track) track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); mark(i); }
      if (track) track.addEventListener('scroll', function () { mark(current()); }, { passive: true });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(Number(t.dataset.ocThumb)); }); });
      dots.forEach(function (d) { d.addEventListener('click', function () { go(Number(d.dataset.ocDot)); }); });

      // desktop: the main photo is sized so all of it fits in the window under the header,
      // and the gallery sits next to the buy box
      var gal = pdp.querySelector('.gal');
      var grid = pdp.querySelector('.pdp');
      var bx = pdp.querySelector('.bx');
      function fitGal() {
        if (!gal || !grid || !bx || window.innerWidth <= 600) return;
        var gs = getComputedStyle(grid);
        var room = grid.clientWidth - parseFloat(gs.paddingLeft) - parseFloat(gs.paddingRight) - bx.offsetWidth - parseFloat(gs.columnGap);
        var th = pdp.querySelector('.thumbs');
        if (th) room -= th.offsetWidth + parseFloat(getComputedStyle(gal).columnGap);
        var top = Math.min(gal.getBoundingClientRect().top + window.scrollY, window.innerHeight * 0.4);
        var h = Math.min(window.innerHeight - top - 24, room * 4 / 3);
        gal.style.setProperty('--oc-gh', Math.max(320, Math.round(h)) + 'px');
      }
      fitGal();
      window.addEventListener('resize', fitGal);

      var sizes = pdp.querySelector('[data-oc-pdp-sizes]');
      var msg = pdp.querySelector('[data-oc-pdp-msg]');
      var atb = pdp.querySelector('[data-oc-pdp-atb]');
      var qtyN = pdp.querySelector('[data-oc-qty-n]');
      var qty = 1;
      var sel = null;
      function say(t, ok) { if (msg) { msg.textContent = t || ''; msg.classList.toggle('ok', !!ok); } }

      if (sizes) sizes.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b || b.disabled) return;
        sizes.querySelectorAll('button').forEach(function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        sel = b.dataset.id;
        selSize = b.dataset.size;
        setPre(b.dataset.pre || '');
        sizes.classList.remove('need');
        say('');
        setQty(qty, true);
      });
      // pre-order sizes: the button says Pre-order and the dispatch note from the pre-order app shows
      var preBox = pdp.querySelector('[data-oc-pre]');
      var preText = pdp.querySelector('[data-oc-pre-text]');
      var atbWord = 'Add to bag';
      function setPre(t) {
        atbWord = t ? 'Pre-order' : 'Add to bag';
        var l = atb && atb.querySelector('[data-oc-atb-label]');
        if (l) l.textContent = atbWord;
        if (preBox) preBox.hidden = !t;
        if (preText) preText.textContent = t;
      }
      // quantity: capped at the stock left in the chosen size (before a size is chosen, the most in any size)
      var selSize = '';
      function maxQty() {
        var bs = sizes ? sizes.querySelectorAll('button:not([disabled])') : [];
        var cur = sel && sizes ? sizes.querySelector('button[data-id="' + sel + '"]') : null;
        if (cur) return Math.max(1, Number(cur.dataset.max) || 99);
        var m = 1;
        bs.forEach(function (x) { m = Math.max(m, Number(x.dataset.max) || 99); });
        return m;
      }
      var qtyPlus = pdp.querySelector('[data-oc-qty="1"]');
      var qtyMinus = pdp.querySelector('[data-oc-qty="-1"]');
      function setQty(n, quiet) {
        var max = maxQty();
        if (n > max && !quiet && sel) say('Only ' + max + ' left in size ' + selSize + '.');
        else if (n <= max && !quiet) say('');
        if (n > max && quiet && sel) say('Only ' + max + ' left in size ' + selSize + ', so we have changed the quantity.');
        qty = Math.max(1, Math.min(max, n));
        if (qtyN) qtyN.textContent = qty;
        if (qtyPlus) qtyPlus.classList.toggle('is-max', qty >= max);
        if (qtyMinus) qtyMinus.classList.toggle('is-max', qty <= 1);
      }
      pdp.querySelectorAll('[data-oc-qty]').forEach(function (b) {
        b.addEventListener('click', function () { setQty(qty + Number(b.dataset.ocQty)); });
      });
      setQty(1, true);
      function add() {
        if (!sel) {
          sizes.classList.add('need');
          say('Please choose a size first.');
          sizes.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        var label = atb.querySelector('[data-oc-atb-label]');
        if (label) label.textContent = 'Adding…';
        postCart([sel], qty).then(function (res) {
          if (label) label.textContent = atbWord;
          if (!res.ok) { say(res.json && res.json.description ? res.json.description : 'Something went wrong. Please try again.'); return; }
          say('Added to your bag.', true);
          showCart(res);
        }).catch(function () { if (label) label.textContent = atbWord; say('Something went wrong. Please try again.'); });
      }
      if (atb) atb.addEventListener('click', add);

      // Complete your set: + opens the quick add sheet for that piece
      pdp.querySelectorAll('[data-oc-set-plus]').forEach(function (b) {
        b.addEventListener('click', function () {
          var card = b.closest('.si').querySelector('[data-oc-set-card]');
          if (card) openQuickSheet(card);
        });
      });
    });
  }

  // fabric hotspots: the + points and the chips (mobile) pick which note shows
  function initHotspots(root) {
    root.querySelectorAll('[data-oc-hot]').forEach(function (sec) {
      if (sec.dataset.ocReady) return;
      sec.dataset.ocReady = '1';
      sec.addEventListener('click', function (e) {
        var b = e.target.closest('[data-oc-hot-i]');
        if (!b) return;
        var i = b.dataset.ocHotI;
        sec.querySelectorAll('[data-oc-hot-i]').forEach(function (x) { x.classList.toggle('is-on', x.dataset.ocHotI === i); });
        sec.querySelectorAll('[data-oc-tip]').forEach(function (t) { t.classList.toggle('alt', t.dataset.ocTip !== i); });
      });
    });
  }

  // cart drawer: discount codes (applied through the cart, so they carry to checkout)
  function redrawCart(sections) {
    var html = sections && sections['cart-drawer'];
    var inner = document.querySelector('#CartDrawer .drawer__inner');
    if (!html || !inner) return;
    var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.drawer__inner');
    if (fresh) inner.innerHTML = fresh.innerHTML;
    var cd = document.querySelector('cart-drawer');
    if (cd) cd.classList.toggle('is-empty', !inner.querySelector('.cd-item'));
    fillRecs();
  }
  function setCodes(codes, msgFor) {
    return fetch(cartRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(','), sections: 'cart-drawer' })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      redrawCart(cart.sections);
      if (!msgFor) return;
      var found = (cart.discount_codes || []).filter(function (d) { return d.code.toUpperCase() === msgFor.toUpperCase(); })[0];
      var msg = document.querySelector('[data-oc-code-msg]');
      if (msg && !found) msg.textContent = msgFor + " isn't a valid code.";
    });
  }
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-oc-code-form]');
    if (!f) return;
    e.preventDefault();
    var input = f.querySelector('input');
    var code = (input.value || '').trim();
    var msg = document.querySelector('[data-oc-code-msg]');
    if (!code) { if (msg) msg.textContent = 'Enter a discount code.'; return; }
    var box = f.closest('[data-oc-code]');
    var have = (box.dataset.codes || '').split(',').filter(Boolean);
    if (have.some(function (c) { return c.toUpperCase() === code.toUpperCase(); })) { if (msg) msg.textContent = code + ' is already applied.'; return; }
    f.classList.add('is-busy');
    setCodes(have.concat(code), code).catch(function () {
      f.classList.remove('is-busy');
      if (msg) msg.textContent = 'Something went wrong. Please try again.';
    });
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-oc-code-remove]');
    if (!b) return;
    var box = b.closest('[data-oc-code]');
    var have = (box.dataset.codes || '').split(',').filter(function (c) { return c && c !== b.dataset.ocCodeRemove; });
    setCodes(have);
  });

  // cart drawer suggestions. With one product in the bag: "Complete the set", the matching pieces in the
  // same colour (a top suggests the trousers and joggers, a bottom suggests the classic and mandarin tops).
  // Otherwise, or when there's no match: "You might also like" from Shopify's related products.
  // Each card has a quick add: + shows the sizes, a size adds it to the bag.
  var recCache = {};
  function getJSON(url) {
    return recCache[url] || (recCache[url] = fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }));
  }
  function setPieces(title) {
    var parts = title.split(' - ');
    if (parts.length < 2) return null;
    var base = parts[0].toLowerCase().replace(/’/g, "'");
    var g = base.indexOf("women's") === 0 ? 'womens' : base.indexOf("men's") === 0 ? 'mens' : '';
    if (!g) return null;
    var styles = /scrub top/.test(base) ? ['scrub-trousers', 'scrub-joggers']
      : /trousers|joggers/.test(base) ? ['classic-scrub-top', 'mandarin-scrub-top'] : null;
    if (!styles) return null;
    var col = parts[parts.length - 1].toLowerCase().trim().replace(/[^a-z0-9]+/g, '-');
    return styles.map(function (st) { return g + '-' + st + '-' + col; });
  }
  function recKey(v) {
    var a = v.selling_plan_allocations && v.selling_plan_allocations[0];
    return a ? v.id + ':' + a.selling_plan_id : String(v.id);
  }
  function recCard(x) {
    var img = x.featured_image || (x.images && x.images[0]) || '';
    if (img && typeof img === 'object') img = img.src || '';
    if (img) img = img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=300';
    var sale = x.compare_at_price > x.price;
    var parts = x.title.split(' - ');
    var sizes = (x.variants || []).map(function (v) {
      var pre = v.available && v.selling_plan_allocations && v.selling_plan_allocations.length;
      return '<button type="button" data-oc-rec-add="' + recKey(v) + '"' + (pre ? ' class="pre" title="Pre-order"' : '') + (v.available ? '' : ' disabled') + '>' + v.title + '</button>';
    }).join('');
    return '<div class="cd-rec">' +
      '<span class="ph"><a href="' + x.url + '" tabindex="-1">' + (img ? '<img src="' + img + '" alt="" loading="lazy" width="112" height="150">' : '') + '</a>' +
      '<button type="button" class="qa" data-oc-rec-qa aria-label="Quick add ' + x.title.replace(/"/g, '&quot;') + '">+</button>' +
      '<span class="szs" data-oc-rec-sizes>' + sizes + '</span></span>' +
      '<a href="' + x.url + '"><b>' + parts[0] + '</b>' + (parts[1] ? '<span class="c">' + parts[1] + '</span>' : '') + '</a>' +
      '<span class="p"><span class="' + (sale ? 'sale' : '') + '">' + money(x.price) + '</span>' + (sale ? '<s>' + money(x.compare_at_price) + '</s>' : '') + '</span></div>';
  }
  function fillRecs() {
    var box = document.querySelector('#CartDrawer [data-oc-recs]');
    if (!box || box.dataset.ocDone || !box.dataset.pid) return;
    box.dataset.ocDone = '1';
    var have = (box.dataset.have || '').split(',');
    var title = box.dataset.title || '';
    // matching pieces come from the drawer markup (found by title); the handle guess is only a fallback
    var pieces = box.dataset.set ? box.dataset.set.split(',') : box.dataset.single ? setPieces(title) : null;
    var setP = pieces
      ? Promise.all(pieces.map(function (h) { return getJSON(cartRoot() + 'products/' + h + '.js'); }))
        .then(function (l) { return l.filter(function (x) { return x && x.available && have.indexOf(String(x.id)) < 0; }); })
      : Promise.resolve([]);
    setP.then(function (set) {
      if (set.length) return { head: 'Complete the set', list: set.slice(0, 2) };
      return getJSON(cartRoot() + 'recommendations/products.json?product_id=' + box.dataset.pid + '&limit=10&intent=related').then(function (j) {
        var low = title.toLowerCase().replace(/’/g, "'");
        var pref = low.indexOf("women's") === 0 ? "women's" : low.indexOf("men's") === 0 ? "men's" : '';
        var list = ((j && j.products) || []).filter(function (x) {
          if (!x.available || have.indexOf(String(x.id)) > -1) return false;
          return !pref || x.title.toLowerCase().replace(/’/g, "'").indexOf(pref) === 0;
        }).slice(0, 6);
        return { head: 'You might also like', list: list };
      });
    }).then(function (r) {
      var rail = box.querySelector('[data-oc-recs-rail]');
      if (!r.list.length || !rail) return;
      box.querySelector('[data-oc-recs-h]').textContent = r.head;
      rail.innerHTML = r.list.map(recCard).join('');
      box.hidden = false;
    });
  }
  document.addEventListener('click', function (e) {
    var qa = e.target.closest('[data-oc-rec-qa]');
    if (qa) {
      var card = qa.closest('.cd-rec');
      var open = !card.classList.contains('is-open');
      document.querySelectorAll('#CartDrawer .cd-rec.is-open').forEach(function (c) { c.classList.remove('is-open'); });
      card.classList.toggle('is-open', open);
      qa.textContent = open ? '×' : '+';
      return;
    }
    var sz = e.target.closest('[data-oc-rec-add]');
    if (!sz || sz.disabled) return;
    var c = sz.closest('.cd-rec');
    c.classList.add('is-busy');
    postCart([sz.dataset.ocRecAdd]).then(function (res) {
      c.classList.remove('is-busy');
      if (!res.ok) { sz.disabled = true; return; }
      showCart(res);
    }).catch(function () { c.classList.remove('is-busy'); });
  });
  // prices in the shopper's own currency. The template is Liquid's money filter applied to 0
  // (set in oc-head), e.g. "£0.00", "€0,00" or "0,00 kr", so it matches the prices Liquid prints
  var moneyTpl;
  function money(c) {
    if (moneyTpl == null) {
      var d = document.createElement('textarea');
      d.innerHTML = window.ocMoneyFormat || '\u00a30.00';
      moneyTpl = d.value;
    }
    var m = moneyTpl.match(/0(?:([.,])0+)?/);
    if (!m) return moneyTpl;
    var dec = m[1] || '';
    var n = (Number(c) || 0) / 100;
    var p = (dec ? n.toFixed(2) : String(Math.round(n))).split('.');
    p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, dec === ',' ? '.' : ',');
    return moneyTpl.replace(m[0], p[0] + (dec ? dec + p[1] : ''));
  }
  // change size in the bag: add the new size with the same quantity, then take the old line out
  // captured on the document so the theme's quantity checker (cart.js) never sees the size select
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-oc-size-change]');
    if (!sel) return;
    e.stopPropagation();
    var item = sel.closest('.cd-item');
    var err = document.querySelector('#CartDrawer-LineItemError-' + sel.dataset.line + ' .cart-item__error-text');
    var was = sel.querySelector('option[selected]');
    var p = sel.value.split(':');
    var add = { id: Number(p[0]), quantity: Number(sel.dataset.qty) || 1 };
    if (p[1]) add.selling_plan = Number(p[1]);
    if (err) err.textContent = '';
    if (item) item.classList.add('is-busy');
    var post = function (url, body) {
      return fetch(cartRoot() + url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
    };
    post('cart/add.js', { items: [add] })
      .then(function () { return post('cart/change.js', { id: sel.dataset.key, quantity: 0, sections: 'cart-drawer' }); })
      .then(function (cart) {
        redrawCart(cart.sections);
        var bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble span, [data-oc-cart-count]');
        if (bubble && cart.item_count != null) bubble.textContent = cart.item_count;
      })
      .catch(function (j) {
        if (item) item.classList.remove('is-busy');
        if (was) sel.value = was.value;
        if (err) err.textContent = (j && (j.description || j.message)) || "We couldn't change the size. Please try again.";
      });
  }, true);

  // codes the cart holds but the markup didn't list (e.g. one that doesn't apply to the bag yet)
  // get a row from cart.js, so every code can be removed
  function fillCodes() {
    var box = document.querySelector('#CartDrawer [data-oc-code]');
    if (!box || box.dataset.ocChecked) return;
    box.dataset.ocChecked = '1';
    fetch(cartRoot() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        var codes = ((cart && cart.discount_codes) || []);
        var have = (box.dataset.codes || '').split(',').filter(Boolean);
        var up = function (c) { return c.toUpperCase(); };
        var extra = codes.filter(function (d) { return have.map(up).indexOf(up(d.code)) < 0; });
        if (!extra.length) return;
        var ul = box.querySelector('.cd-codes');
        if (!ul) { ul = document.createElement('ul'); ul.className = 'cd-codes'; ul.setAttribute('role', 'list'); box.querySelector('[data-oc-code-msg]').before(ul); }
        extra.forEach(function (d) {
          var li = document.createElement('li');
          if (!d.applicable) li.className = 'is-bad';
          li.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 12V4h8l10 10-8 8L3 12z"/><circle cx="7.5" cy="8.5" r="1.5"/></svg><span><b></b>' + (d.applicable ? ' applied' : " can't be used on this bag") + '</span><button type="button">Remove</button>';
          li.querySelector('b').textContent = d.code;
          var b = li.querySelector('button');
          b.setAttribute('data-oc-code-remove', d.code);
          b.setAttribute('aria-label', 'Remove discount code ' + d.code);
          ul.appendChild(li);
        });
        box.dataset.codes = have.concat(extra.map(function (d) { return d.code; })).join(',');
        box.classList.add('has-code');
      }).catch(function () {});
  }
  // free-delivery bar for shoppers paying in another currency: the threshold is set in pounds,
  // so convert it at the rate Shopify uses for this market before comparing with the bag total
  function fillShip() {
    var bar = document.querySelector('#CartDrawer [data-oc-ship]');
    if (!bar || bar.dataset.ocDone) return;
    bar.dataset.ocDone = '1';
    var rate = window.Shopify && Shopify.currency && Number(Shopify.currency.rate);
    if (!rate) return;
    var from = Math.round(Number(bar.dataset.from) * rate);
    var total = Number(bar.dataset.total) || 0;
    var left = from - total;
    bar.querySelector('p').innerHTML = left > 0
      ? 'You\'re <b>' + money(left) + '</b> away from <b>Free Delivery</b>'
      : 'You\'ve unlocked <b>Free Delivery</b>';
    bar.querySelector('.cd-bar i').style.width = Math.min(100, Math.floor(total * 100 / from)) + '%';
    bar.hidden = false;
  }
  // bag timer: the deadline is set the first time the drawer shows items and kept in localStorage,
  // so it carries on across page loads and drawer re-renders; it clears once the bag is empty.
  // It counts down once and stops, it never restarts while items are still in the bag.
  var TIMER_KEY = 'oc-bag-timer';
  var timerTick = null;
  function store(v) {
    try { if (v == null) localStorage.removeItem(TIMER_KEY); else localStorage.setItem(TIMER_KEY, v); } catch (e) {}
  }
  function stored() {
    try { return Number(localStorage.getItem(TIMER_KEY)) || 0; } catch (e) { return 0; }
  }
  function fillTimer() {
    var box = document.querySelector('#CartDrawer [data-oc-timer]');
    if (!box) {
      if (!document.querySelector('#CartDrawer .cd-item')) store(null);
      clearInterval(timerTick); timerTick = null;
      return;
    }
    var end = stored();
    if (!end) { end = Date.now() + Number(box.dataset.min) * 60000; store(end); }
    var paint = function () {
      var el = document.querySelector('#CartDrawer [data-oc-timer]');
      if (!el) return;
      var left = Math.max(0, end - Date.now());
      if (!left) {
        if (!el.classList.contains('is-done')) {
          el.classList.add('is-done');
          el.querySelector('p').textContent = el.dataset.done;
        }
        clearInterval(timerTick); timerTick = null;
        return;
      }
      var s = Math.ceil(left / 1000);
      var t = el.querySelector('[data-oc-timer-t]');
      var txt = Math.floor(s / 60) + ':' + ('0' + (s % 60)).slice(-2);
      // write the text node, not textContent, so the drawer's MutationObserver isn't woken every second
      if (t && t.firstChild && t.firstChild.nodeValue !== txt) t.firstChild.nodeValue = txt;
    };
    paint();
    if (!timerTick && end > Date.now()) timerTick = setInterval(paint, 1000);
  }
  ready(function watchDrawer() {
    var cd = document.getElementById('CartDrawer');
    if (!cd) return;
    var run = function () { fillRecs(); fillCodes(); fillShip(); fillTimer(); };
    run();
    new MutationObserver(run).observe(cd, { childList: true, subtree: true });
  });

  function init(root) {
    root = root || document;
    initRails(root);
    initTabs(root);
    initFeat(root);
    initAccordions(root);
    initCards(root);
    initAutoplay(root);
    initDrag(root);
    initCollGrid(root);
    initCollSet(root);
    initCollHero(root);
    initPdp(root);
    initHotspots(root);
  }

  document.addEventListener('touchstart', function () {}, { passive: true });

  ready(function () {
    measureHeader();
    initDialogs();
    initHeader();
    init(document);
  });
  window.addEventListener('resize', measureHeader);
  window.addEventListener('load', measureHeader);
  // re-run when a section is edited in the theme editor
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
